import { createStore } from 'vuex';

export const store = createStore({
  state: () => {
    return {
      user: {},
      curQuestionId: '',
      questionObj: {},
      questionIdList: []
    };
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setCurQuestionId(state, curQuestionId) {
      state.curQuestionId = curQuestionId;
    },
    setQuestionIdList(state, questionIdList) {
      state.questionIdList = questionIdList;
    },
    setQuestionObj(state, questionObj) {
      state.questionObj = questionObj;
    }
  },
  getters: {
    getUser(state) {
      return state.user;
    },
    getQuestionIdList(state) {
      return state.questionIdList;
    }
  }
});
